import React from 'react';
import { Dialog, DialogContent, Typography, Box, useMediaQuery } from '@mui/material';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

export const CustomDialog: React.FC<{
  title: string;
  errorMessage: string;
  isOpen: boolean;
  onClose: () => void;
}> = ({ title, errorMessage, isOpen, onClose }) => {
  const { theme } = useThemeContext();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={isOpen}
      disableEscapeKeyDown={true}
      disableScrollLock={true}
      onClose={() => {}}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '16px !important',
        },
      }}
    >
      <DialogContent
        sx={{
          width: isSmallScreen ? '300px' : '500px',
          height: 'auto',
          gap: '16px',
          background: theme.custom.components.customDialog.content.backgroundColor,
          color: theme.custom.components.customDialog.content.color,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h6" sx={{ color: theme.custom.components.customDialog.content.title.color }}>
            {title}
          </Typography>
          <img
            src={theme.custom.components.customDialog.content.closeIcon.src}
            alt="Close"
            onClick={onClose}
            style={{
              marginTop: '4px',
              cursor: 'pointer',
              width: '24px',
              height: '24px',
            }}
          />
        </Box>
        <Typography variant="body1" dangerouslySetInnerHTML={{ __html: errorMessage }}></Typography>
      </DialogContent>
    </Dialog>
  );
};
